var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"button",on:{"click":function($event){_vm.showingModal = true}}},[_vm._t("default")],2),_vm._v(" "),(_vm.showingModal)?_c('QuoteRequestModal',{staticClass:"quote-modal",attrs:{"request_id":_vm.request_id},on:{"close":function($event){_vm.showingModal = false}}}):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c37e39","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/QuoteRequestButton.vue
// module id = 9BiY
// module chunks = 1